export var ReadyState;
(function (ReadyState) {
    ReadyState["loading"] = "loading";
    ReadyState["started"] = "started";
})(ReadyState || (ReadyState = {}));
